let globalUuid = 0;

/**
 * Logic can be used to add a unique id for every instance of a component.
 *
 * @returns {Object}
 */
export default () => {
  globalUuid += 1;

  return {
    uuid: globalUuid,
  };
};
